import {useTranslation} from '../context/TranslationContext';
import {Marketplace} from '../types';

interface MarketplaceTableProps {
    marketplaces: Marketplace[];
    selectedMarketplaceId: number | null;
    onSelect: (id: number) => void;
}

const StatusLabel = ({active}: {active?: boolean | null}) => {
    const {t} = useTranslation();
    return (
        <span className={`label ${active ? 'label-success' : 'label-secondary'}`}>
            {active ? t('active') : t('inactive')}
        </span>
    );
};

export const MarketplaceTable = ({marketplaces, selectedMarketplaceId, onSelect}: MarketplaceTableProps) => {
    const {t} = useTranslation();

    if (marketplaces.length === 0) {
        return (
            <div className="text-center text-muted py-5">
                {t('apx-marketplaces-no-marketplaces')}
            </div>
        );
    }

    return (
        <table className="table table-autofit table-hover table-list">
            <thead>
                <tr>
                    <th>{t('name')}</th>
                    <th>{t('prefix')}</th>
                    <th>{t('status')}</th>
                    <th>{t('apx-marketplaces-connected-suppliers-count')}</th>
                </tr>
            </thead>
            <tbody>
                {marketplaces.map((marketplace) => (
                    <tr
                        className={marketplace.id === selectedMarketplaceId ? 'table-active' : ''}
                        key={marketplace.id}
                        onClick={() => onSelect(marketplace.id)}
                        style={{cursor: 'pointer'}}
                    >
                        <td className="table-cell-expand">
                            {marketplace.displayName || marketplace.name}
                        </td>
                        <td>{marketplace.prefix}</td>
                        <td>
                            <StatusLabel active={marketplace.active} />
                        </td>
                        <td>{marketplace.marketplaceSuppliers.length}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
